// extracted by mini-css-extract-plugin
export default {"EditorWrapper":"EditorWrapper_EditorWrapper__GfIJu","HeaderTitle":"EditorWrapper_HeaderTitle__bo7J3","ShareButton":"EditorWrapper_ShareButton__GILe2"};